/* BushLine product tabs - 14 Oct 2026 (thread AF, the owner's locked tab design).
   Desktop (769 px and up): three width buttons in the open panel's top-right corner - narrow (the column, as before),
   wide and full page width. Wide and full lift the description out of the left column into its own row under the photos
   and buy box (the theme stretches the buy-box column to the description's height, so it cannot just widen in place).
   The customer's pick stays put; nothing widens by itself. Clicking the open tab again closes it.
   Every open panel (desktop and phone) ends with "Back to the Top of the Tabs": up to the tab row, back to narrow. */
(function () {
  if (window.blTabsW) return; window.blTabsW = true;
  var KEY = 'blTabsWidth', mq = window.matchMedia('(min-width: 769px)');
  var width = 0; try { width = +sessionStorage.getItem(KEY) || 0; } catch (e) {}
  function root() { return document.querySelector('.station-tabs'); }
  function cont() { var r = root(); return r && r.closest('.container'); }
  function panels() { var r = root(); return r ? r.querySelectorAll('.station-tabs-content-inner') : []; }
  function apply() {
    var c = cont(); if (!c) return;
    var on = mq.matches && width > 0;
    document.documentElement.classList.toggle('bl-desc-wide', on && width === 1);
    document.documentElement.classList.toggle('bl-desc-full', on && width === 2);
    document.querySelectorAll('.bl-tabw button[data-w]').forEach(function (b) { var is = +b.getAttribute('data-w') === width; b.classList.toggle('is-on', is); b.setAttribute('aria-pressed', is ? 'true' : 'false'); });
  }
  function decorate() {
    var r = root(); if (!r) return;
    panels().forEach(function (p) {
      if (!p.querySelector(':scope > .bl-tabw')) {
        var bar = document.createElement('div'); bar.className = 'bl-tabw'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Panel Width');
        bar.innerHTML = '<button type="button" data-w="0" title="Narrow">▯</button><button type="button" data-w="1" title="Wide">▭</button><button type="button" data-w="2" title="Full Width">⬜</button>';
        p.insertBefore(bar, p.firstChild);
      }
      if (!p.querySelector(':scope > .bl-btt')) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'bl-btt'; b.textContent = '▲ Back to the Top of the Tabs';
        p.appendChild(b);
      }
    });
    apply();
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('.bl-tabw button[data-w]');
    if (w) {
      width = +w.getAttribute('data-w'); try { sessionStorage.setItem(KEY, width); } catch (x) {}
      apply();
      var r = root(); if (r && width > 0) r.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    if (e.target.closest('.bl-btt')) {
      width = 0; try { sessionStorage.setItem(KEY, 0); } catch (x) {}
      apply();
      var r2 = root(); if (r2) { var y = r2.getBoundingClientRect().top + window.scrollY - 110; window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
      return;
    }
    // clicking the open tab again closes it (desktop); clicking any tab opens it again
    var link = e.target.closest('.station-tabs > a.station-tabs-link, .station-tabs a.station-tabs-link');
    var r3 = root();
    if (link && r3 && mq.matches && !r3.classList.contains('mod-full-width')) {
      if (link.classList.contains('is-active') && !r3.classList.contains('bl-tabs-closed')) {
        e.preventDefault(); e.stopImmediatePropagation(); r3.classList.add('bl-tabs-closed');
        // the closed tab takes the look of a closed one (the app's colours, read off a tab that isn't open)
        var other = r3.querySelector('a.station-tabs-link:not(.is-active)');
        if (other) { var cs = getComputedStyle(other); ['background-color', 'color', 'border-color'].forEach(function (p) { link.style.setProperty(p, cs.getPropertyValue(p), 'important'); }); link.setAttribute('data-bl-closed', '1'); }
        link.setAttribute('aria-selected', 'false');
      } else {
        r3.classList.remove('bl-tabs-closed');
        r3.querySelectorAll('a[data-bl-closed]').forEach(function (a) { ['background-color', 'color', 'border-color'].forEach(function (p) { a.style.removeProperty(p); }); a.removeAttribute('data-bl-closed'); });
      }
    }
  }, true);
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(decorate, 80); });
  // Tabs Studio rebuilds .station-tabs on every variant change, so watch the page's main area, not the tabs element itself
  var watching = false;
  function start() { decorate(); if (!watching) { var m = document.querySelector('main') || document.body; mo.observe(m, { childList: true, subtree: true }); watching = true; } }
  if (mq.addEventListener) mq.addEventListener('change', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // Tabs Studio builds the tabs after load
  var tries = 0, iv = setInterval(function () { tries++; if (root() && root().classList.contains('is-ready')) { clearInterval(iv); start(); } else if (tries > 40) clearInterval(iv); }, 250);
})();
